import React from 'react';
import { Grid } from '@material-ui/core';
import SkillsProgress from '../common/SkillsProgress';
import Engagement from './Engagement';
import OverallCards from '../common/OverallCards';
import { ReportEntityType } from 'components/ReportsModule/types';
import useSkillProgress from '../hooks/use-skill-progress';
import { useQuery } from '@apollo/client';
import GET_STUDENT_ENGAGEMENT_REPORT from 'graph/reports/get-student-engagement-report';
import { baseWhere } from 'graph/apollo-util';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { PrmStudentEngagementReportResult } from 'types/schema-generated-types';

const PrmClassroomReport = () => {
  const [
    {
      setList,
      selectedProductCurriculumId,
      prmCurriculumProgressReport,
      curriculumLessonReport,
      curriculumLessonLoading
    },
    { setSelectedProductCurriculumId }
  ] = useSkillProgress();
  const [{ entityId }] = useReportQueryParams();
  const { data } = useQuery<{ prmStudentEngagementReport: PrmStudentEngagementReportResult }>(
    GET_STUDENT_ENGAGEMENT_REPORT,
    baseWhere({ classroomId: entityId })
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OverallCards prmCurriculumProgressReport={prmCurriculumProgressReport} />
      </Grid>
      <Grid item xs={12}>
        <SkillsProgress
          curriculumLessonReport={curriculumLessonReport!}
          setSelected={setSelectedProductCurriculumId}
          selected={selectedProductCurriculumId}
          entityType={ReportEntityType.CLASSROOM}
          setList={setList}
          loading={curriculumLessonLoading!}
        />
      </Grid>
      <Grid item xs={12}>
        <Engagement prmStudentEngagementReport={data?.prmStudentEngagementReport!} />
      </Grid>
    </Grid>
  );
};

export default PrmClassroomReport;
